/*
  Il regalo, in una finestra sua (5 ottobre 2026), sul modello dell'incisione.

  Nel form della scheda stanno quattro campi nascosti, spenti finché il
  regalo non c'è: properties[Regalo per], properties[Dedica],
  properties[Senza prezzo] e properties[_regalo]. La voce "È un regalo" (e
  ogni altro elemento con data-regalo-apri) apre la finestra. I campi della
  finestra non hanno name: alla conferma i loro valori si copiano nei campi
  nascosti, che si accendono; un campo vuoto resta spento, e all'ordine non
  parte. Il nome di chi lo riceve è obbligatorio, la dedica no e ha il suo
  contatore; la spunta del pacco senza prezzo compare solo quando la sezione
  la accende (regalo_senza_prezzo_attivo). Sotto la
  voce compare il nome scelto, con il modo di toglierlo: Togli svuota tutto.

  Il velo non chiude: una dedica scritta a metà non si perde con un clic
  sbagliato. Chiudono Esc, Annulla e la X, senza salvare niente; alla
  riapertura la finestra riparte da quello che è confermato.

  Il Rito lascia la sua dedica in sessionStorage, sotto daymonilia-dedica:
  {v: 1, handle, dono, per, dedica, firma}. Conta solo il Rito fatto per
  un'altra persona (dono vero): la dedica del Rito fatto per sé descrive chi
  l'ha fatto, non chi riceve il regalo. Se i campi nascosti sono vuoti e la
  dedica è per questo monile (handle uguale alla prima parte dell'handle del
  prodotto, che arriva come data-natura), la finestra si apre già scritta:
  il nome e la dedica. La firma del Rito (il monile, Napoli, la data) resta
  sulla pagina nera e non entra nella dedica dell'ordine: nel biglietto del
  pacco uscirebbe firmata dal monile. Non si conferma mai da sola.

  I valori fissi delle proprietà ("Sì" con l'accento, "1") arrivano dal
  Liquid in data-acceso. Ogni testo visibile arriva dal Liquid: qui dentro
  non si scrive una parola.
*/

(function () {
  'use strict';

  var CHIAVE_RITO = 'daymonilia-dedica';

  var modale = document.querySelector('[data-regalo-modale]');
  var valorePer = document.querySelector('[data-regalo-per-valore]');
  if (!modale || !valorePer || typeof modale.showModal !== 'function') return;

  var valoreDedica = document.querySelector('[data-regalo-dedica-valore]');
  var valoreSenzaPrezzo = document.querySelector('[data-regalo-senza-prezzo-valore]');
  var valoreRegalo = document.querySelector('[data-regalo-valore]');

  var campoPer = modale.querySelector('[data-regalo-per]');
  var campoDedica = modale.querySelector('[data-regalo-dedica]');
  var spunta = modale.querySelector('[data-regalo-senza-prezzo]');
  var contatore = modale.querySelector('[data-regalo-contatore]');
  var errore = modale.querySelector('[data-regalo-errore]');
  var conferma = modale.querySelector('[data-regalo-conferma]');
  var scelta = document.querySelector('[data-regalo-scelta]');
  var sceltaTesto = document.querySelector('[data-regalo-scelta-testo]');
  var togli = document.querySelector('[data-regalo-togli]');
  var voci = document.querySelectorAll('[data-regalo-apri]');

  var natura = String(modale.getAttribute('data-natura') || '').toLowerCase();
  var modelloContatore = contatore ? contatore.getAttribute('data-modello') || '@n/@tot' : '@n/@tot';
  var modelloScelta = sceltaTesto ? sceltaTesto.getAttribute('data-modello') || '@t' : '@t';
  var massimoPer = campoPer && campoPer.maxLength > 0 ? campoPer.maxLength : 40;
  var massimoDedica = campoDedica && campoDedica.maxLength > 0 ? campoDedica.maxLength : 200;
  var daRimettere = null;

  function misura(nome, dettaglio) {
    if (!window.Daymonilia || typeof window.Daymonilia.misura !== 'function') return;
    try { window.Daymonilia.misura(nome, dettaglio); } catch (e) { /* la misura non ferma mai il regalo */ }
  }

  function pulito(testo) {
    return String(testo || '').replace(/^\s+|\s+$/g, '');
  }

  /* Un modello con la sua sentinella: il testo entra con una funzione, così un $ resta un $. */
  function riempi(modello, sentinella, testo) {
    return modello.replace(sentinella, function () { return testo; });
  }

  function acceso(campo) {
    return campo ? campo.getAttribute('data-acceso') || '' : '';
  }

  /* Un campo nascosto vuoto resta spento: FormData e il form senza JavaScript lo lasciano a terra. */
  function imposta(campo, testo) {
    if (!campo) return;
    campo.value = testo;
    campo.disabled = !testo;
  }

  function contaDedica() {
    if (!contatore) return;
    var lunghezza = campoDedica ? campoDedica.value.length : 0;
    contatore.textContent = riempi(riempi(modelloContatore, '@n', String(lunghezza)), '@tot', String(massimoDedica));
  }

  function mostraErrore(visibile) {
    if (errore) errore.hidden = !visibile;
    if (!campoPer) return;
    if (visibile) {
      campoPer.setAttribute('aria-invalid', 'true');
      if (errore && errore.id) campoPer.setAttribute('aria-describedby', errore.id);
    } else {
      campoPer.removeAttribute('aria-invalid');
      campoPer.removeAttribute('aria-describedby');
    }
  }

  function scriviScelta() {
    var per = pulito(valorePer.value);
    if (scelta) scelta.hidden = !per;
    if (sceltaTesto) sceltaTesto.textContent = per ? riempi(modelloScelta, '@t', per) : '';
  }

  /* Scrive i quattro campi nascosti. Senza il nome si spengono tutti. */
  function scrivi(per, dedica, senzaPrezzo) {
    per = pulito(per).slice(0, massimoPer);
    imposta(valorePer, per);
    imposta(valoreDedica, per ? pulito(dedica).slice(0, massimoDedica) : '');
    imposta(valoreSenzaPrezzo, per && senzaPrezzo ? acceso(valoreSenzaPrezzo) : '');
    imposta(valoreRegalo, per ? acceso(valoreRegalo) || '1' : '');
    scriviScelta();
  }

  /* La dedica lasciata dal Rito, solo se è per un'altra persona e per questo monile. Ogni lettura sta nel try: in una finestra privata sessionStorage può mancare. */
  function dedicaDelRito() {
    var dato = null;
    try {
      var grezzo = window.sessionStorage.getItem(CHIAVE_RITO);
      if (grezzo) dato = JSON.parse(grezzo);
    } catch (e) {
      return null;
    }
    if (!dato || dato.v !== 1 || !natura) return null;
    if (!dato.dono) return null;
    if (String(dato.handle || '').toLowerCase() !== natura) return null;
    var per = typeof dato.per === 'string' ? pulito(dato.per) : '';
    var dedica = typeof dato.dedica === 'string' ? pulito(dato.dedica) : '';
    if (!per && !dedica) return null;
    return { per: per.slice(0, massimoPer), dedica: dedica.slice(0, massimoDedica) };
  }

  function apri(bottone) {
    daRimettere = bottone || document.activeElement;
    var per = valorePer.value;
    var dedica = valoreDedica ? valoreDedica.value : '';
    var senzaPrezzo = valoreSenzaPrezzo ? valoreSenzaPrezzo.value !== '' : true;
    var dalRito = null;
    if (!pulito(per) && !pulito(dedica)) {
      /* Nessun regalo confermato: la spunta torna accesa, e se il Rito ha lasciato una dedica la si trova scritta. */
      senzaPrezzo = true;
      dalRito = dedicaDelRito();
      if (dalRito) {
        per = dalRito.per;
        dedica = dalRito.dedica;
      }
    }
    if (campoPer) campoPer.value = per;
    if (campoDedica) campoDedica.value = dedica;
    if (spunta) spunta.checked = senzaPrezzo;
    mostraErrore(false);
    contaDedica();
    modale.showModal();
    if (campoPer) campoPer.focus();
    misura('regalo_apri', { rito: !!dalRito });
  }

  function chiudi() {
    if (modale.open) modale.close();
  }

  modale.addEventListener('close', function () {
    if (daRimettere && typeof daRimettere.focus === 'function') daRimettere.focus();
    daRimettere = null;
  });

  /* Nessun ascolto sul velo, di proposito: il clic fuori non chiude. */

  Array.prototype.forEach.call(voci, function (bottone) {
    bottone.addEventListener('click', function (evento) {
      evento.preventDefault();
      apri(bottone);
    });
  });

  Array.prototype.forEach.call(modale.querySelectorAll('[data-regalo-annulla]'), function (bottone) {
    bottone.addEventListener('click', chiudi);
  });

  if (campoPer) {
    campoPer.addEventListener('input', function () {
      if (pulito(campoPer.value)) mostraErrore(false);
    });
    campoPer.addEventListener('keydown', function (evento) {
      if (evento.key === 'Enter') {
        evento.preventDefault();
        if (conferma) conferma.click();
      }
    });
  }

  if (campoDedica) campoDedica.addEventListener('input', contaDedica);

  if (conferma) {
    conferma.addEventListener('click', function () {
      var per = pulito(campoPer ? campoPer.value : '');
      if (!per) {
        mostraErrore(true);
        if (campoPer) campoPer.focus();
        return;
      }
      var dedica = campoDedica ? campoDedica.value : '';
      var senzaPrezzo = spunta ? spunta.checked : true;
      scrivi(per, dedica, senzaPrezzo);
      misura('regalo_conferma', { dedica: !!pulito(dedica), senza_prezzo: senzaPrezzo });
      chiudi();
    });
  }

  if (togli) {
    togli.addEventListener('click', function () {
      scrivi('', '', false);
      /* Togli sparisce con il regalo: il fuoco torna alla voce. */
      if (voci.length && typeof voci[0].focus === 'function') voci[0].focus();
      misura('regalo_togli');
    });
  }

  /* All'avvio i campi nascosti tornano coerenti, anche se il browser ne ha ricordato un valore. */
  scrivi(valorePer.value, valoreDedica ? valoreDedica.value : '', valoreSenzaPrezzo ? valoreSenzaPrezzo.value !== '' : false);
})();
